/**
 * Adds the clicked size to the cart straight from a product card (the hover size picker rendered
 * by card-product.liquid), then opens the Sternify cart drawer. Event delegation on document so
 * cards added later (infinite scroll, section re-renders) work without re-binding.
 *
 * Sternify patches window.fetch, so a plain /cart/add.js call is enough for the drawer to pick up
 * the new line — it just doesn't open on its own, hence the explicit SternifyCart.open().
 */
(function () {
  function cartAddUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function openCart() {
    if (window.SternifyCart && typeof window.SternifyCart.open === 'function') {
      window.SternifyCart.open();
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-card-quick-sizes] .card-quick-size');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (button.disabled || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(button.getAttribute('data-variant-id')), quantity: 1 }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(openCart)
      .catch(function () {
        button.disabled = true;
        button.classList.add('is-unavailable');
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  });
})();
